// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SVqVtJCkqbE9w9u65uXt{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:628px;margin:0 auto;display:flex}.SVqVtJCkqbE9w9u65uXt .mAvTKLXysqoJ9WNBXieE{flex-direction:row;justify-content:center;gap:8px;display:flex}.SVqVtJCkqbE9w9u65uXt .Y7CF7tfVNoNFrB0qZmBp{text-align:center;flex-direction:column;display:flex}.SVqVtJCkqbE9w9u65uXt .YM00UxhJHXoiUaFYAnv6{border-radius:16px;align-items:flex-end;margin-bottom:40px;display:flex;overflow:hidden}.SVqVtJCkqbE9w9u65uXt .YM00UxhJHXoiUaFYAnv6 img{width:100%;height:auto;display:block}.Zm4YUroCRyMhQlmGkAMO{width:148px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `SVqVtJCkqbE9w9u65uXt`,
	"actions": `mAvTKLXysqoJ9WNBXieE`,
	"title": `Y7CF7tfVNoNFrB0qZmBp`,
	"titlePreview": `YM00UxhJHXoiUaFYAnv6`,
	"guideButton": `Zm4YUroCRyMhQlmGkAMO`
};
export default ___CSS_LOADER_EXPORT___;
